import React from 'react'
import { useMediaQuery } from 'react-responsive';
import { NoItemsLeftInTable, roundToThreeDecimal } from '../../../../helpers/helpers';

function ServiceAuctionReportConfimation({ offers, scrollLength }) {
    const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
    return (
        <div className="table-container-style custom-scrollbar" style={{
            height: offers.length > scrollLength && "200px",
            overflowY: "auto",
            paddingRight: offers.length > 3 && "2px",
        }}>
            <table
                className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
                    }`}
            >
                <thead>
                    <tr>
                        {/* <th>H1-Bidder</th> */}
                        <th>Service Title</th>
                        <th>Category</th>
                        <th>Starting price</th>
                        <th>L1-Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {offers?.map((item) => (
                        <tr key={item?._id}>
                            {/* <td>{item?.bids?.[0]?.organizationName || "N/A"}</td> */}
                            <td>{item?.serviceDetails?.title}</td>
                            <td>{item?.serviceDetails?.category || "N/A"}</td>
                            <td>{item?.startingPrice}</td>
                            <td>{roundToThreeDecimal(item?.mimumestBid) || "N/A"}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {offers?.bids?.length === 0 && <NoItemsLeftInTable />}
        </div>
    )
}

export default ServiceAuctionReportConfimation
